export default {
  s3: {
    REGION: 'us-east-1',
    BUCKET: 'transcription-uploads'
  },
  apiGateway: {
    REGION: 'us-east-1',
    URL: 'https://s3tr4jzb63.execute-api.us-east-1.amazonaws.com/prod'
  },
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_mxklctSzt',
    APP_CLIENT_ID: '2r7uuui72akalf87912tm8nul0',
    IDENTITY_POOL_ID: 'us-east-1:4e707bf1-2a1b-483e-94d6-902c9b182d77'
  }
}



// WEBPACK FOOTER //
// ./src/config.js